/**
 * @param {*} state
 */
export const informations = state => state.informations

/**
 * @param {*} state
 */
export const agency = state => state.agency

/**
 * @param {*} state
 */
// export const user = state => {
//   const { informations } = state

//   const { address } = informations

//   return {
//     name: `${informations.firstname} ${informations.lastname}`,
//     email: informations.email,
//     phone: phone,
//     address: {
//       city: address.city.city,
//       name: address.address,
//       notes: null,
//       number: address.number,
//       country: address.city.state.country.id,
//       district: address.district,
//       complement: address.complement,
//       state: address.city.state.state,
//       state_abbr: address.city.state.state_abbr,
//       postal_code: address.postal_code
//     },
//     document: informations.document,
//     state_register: null,
//     company_document: null
//   }
// }

/**
 * @param {*} state
 */
// export const address = state => {
//     return state.informations.address.city.state.state_abbr
// }
